// 
// -----------------------------------------------------------------------------
(function ($selects) {

	function clickedItem(e) {
	    e.stopPropagation();
	    var $this = $(e.target); 
	    var $stage = $this.closest('.select');
	    $stage.find('select').val($this.attr('rel'));
	    $stage.find('ul').hide().find('li').removeClass('selected');
	    $stage.find('.select-styled').text($this.text()).removeClass('active');
	    $this.addClass('selected');
	}

	function createElements(e){
		var isCreate = e.type !== 'DOMSubtreeModified';
		var $this = isCreate ? $(e) : $(e.target);
		var numberOfOptions = $this.children('option').length;
		var $stage = $this.closest('.select');
		
		$stage.find('.select-options li').remove();
	
		for (var i = 0; i < numberOfOptions; i++) {

		  $('<li />', {
		      text: $this.children('option').eq(i).text(),
		      rel: $this.children('option').eq(i).val()
		  }).bind('click', clickedItem).appendTo($this.siblings('.select-options'));
		}
		
		$this.next().text($this.find(":selected").text());

		if(isCreate){
			$this.next().on('click', function(e) {
			    e.stopPropagation();
		        $(this).toggleClass('active').next('ul.select-options').toggle();
			});

			$(document).on('click', function() {
			    $this.next().removeClass('active');
			    $stage.find('ul').hide();
			});
		}
	}

	$selects.each(function () {
		var $this = $(this);
		$this.hide(); 
		$this.wrap('<div class="select"></div>');
		$this.after('<div class="select-styled"></div>');
		$this.parent().append('<ul class="select-options"></ul>');

		createElements($this);

		$this.bind("DOMSubtreeModified", createElements);

	});

})($( 'select' ));
